import { render, staticRenderFns } from "./BodyPortal.vue?vue&type=template&id=5df5762d&scoped=true"
import script from "./BodyPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyPortal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BodyPortal.vue?vue&type=style&index=0&id=5df5762d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df5762d",
  null
  
)

export default component.exports